import { Injectable } from '@angular/core';
import { BusinessRole } from '../model/business-role.model';

export enum DefaultRole {
  IRISH_MARKET_USER = 'IRISH_MARKET_USER',
  DR_GENERAL_USER = 'DR_GENERAL_USER',
  ZENDESK_USER = 'ZENDESK_USER',
  DR_ENERGY_USER = 'DR_ENERGY_USER',
}

export interface DefaultRoleResult {
  roles: BusinessRole[];
  disableRoleSelection: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DefaultRoleService {
  setManagerLocale(loggedInUser: any): string {
    return loggedInUser?.locale ?? 'en_US';
  }

  getDefaultRoles(managerLocale: string, allSpaceRoles: BusinessRole[], isOnboarding: boolean): DefaultRoleResult {
    if (!managerLocale || !allSpaceRoles?.length) {
      return { roles: [], disableRoleSelection: false };
    }
    if (isOnboarding) {
      const roles = this.applyDefaultRoles(managerLocale, allSpaceRoles);
      return { roles, disableRoleSelection: true };
    } else {
      const roles = this.computeDefaultRoles(managerLocale, allSpaceRoles);
      return { roles, disableRoleSelection: false };
    }
  }

  applyDefaultRoles(managerLocale: string, allSpaceRoles: BusinessRole[]): BusinessRole[] {
    const defaultRoleNames = this.defaultRolesByLocale(managerLocale);
    return defaultRoleNames
      .map((roleName) => allSpaceRoles.find((role) => role.name === roleName))
      .filter((role) => role !== undefined) as BusinessRole[];
  }

  computeDefaultRoles(managerLocale: string, allSpaceRoles: BusinessRole[]): BusinessRole[] {
    const defaultRoleNames = this.defaultRolesByLocale(managerLocale);
    const roles: BusinessRole[] = [];
    defaultRoleNames.forEach((roleName) => {
      const role = allSpaceRoles.find((r) => r.name === roleName);
      if (role && !roles.some((r) => r.name === role.name)) {
        roles.push(role);
      }
    });
    return roles;
  }

  defaultRolesByLocale(locale: string): DefaultRole[] {
    switch (locale) {
      case 'en_IE':
        return [DefaultRole.IRISH_MARKET_USER];
      case 'en_US':
      case 'en_CA':
        return [DefaultRole.DR_GENERAL_USER, DefaultRole.ZENDESK_USER];
      default:
        return [DefaultRole.DR_ENERGY_USER];
    }
  }
}
